import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
// import { createTheme } from '@mui/material/styles';
// import
// {
//     View, Text
// } from '@react-pdf/renderer';
import { generatePath } from 'react-router-dom';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MailIcon from '@mui/icons-material/Mail';
import { Downgraded } from '@hookstate/core';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import Logo from '../../assets/images/logo.svg';
import Logo from '../../assets/images/logo.png';
import DefaultEvent from '../../assets/images/default_event.jpg';
import NavBar from '../Nav/NavBar/NavBar';
import { useAuthState } from '../../stores/authStore';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
import { useThemeState, setTheme } from '../../hookState/ThemeState';
import {
    useNotificationState,
    setNotification,
} from '../../hookState/NotifcationState';
import { useHistory } from 'react-router-dom';
import ProfileInitial from '../../sharedcomponents/profile/profileInitial';
import Helper from '../../utility/helper';
// import { useState } from '@hookstate/core';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import Popper from '@mui/material/Popper';
import {
    Paper,
    ClickAwayListener,
    Typography,
    FormControl,
    Select,
    List,
    ListItemButton,
    ListItemText,
    ListItemSecondaryAction,
    Avatar,
    Divider,
    Card,
    CardHeader,
    CircularProgress,
    // Button,
} from '@mui/material';
import { unregister } from '../../registerServiceWorker';
import {
    useAgentState,
    handleAgentClose,
    setAgentVisible,
} from '../../hookState/AgentState';
import {
    useAgentSaveAsDraftState, resetSaveAsDraftState, setAgentUserInfo
} from '../../hookState/AgentSaveAsDraftState';
import { useMsal } from '@azure/msal-react';
import { handleDrawerClose } from '../../hookState/ModuleDrawerState';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { changeAgentUserHandler } from '../../utility/agentChangeUtility';
import { useEventState } from '../../stores/eventStore';

// const theme = createTheme();
const useStyles = makeStyles({
    logo: {
        height: '100%',
    },
    mobileLogo: {
        height: 42,
    },
    whiteFontColor: {
        color: 'white',
    },
    headerTilte: {
        paddingLeft: 0,
        // paddingRight: 11,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '1rem',
        stroke: 'red',
        strokeWidth: 2,
        marginTop: '-3px',
    },
    initialSection: {
        flex: '0 0 auto',
        padding: 12,
        textAlign: 'center',
        marginRight: 0,
    },
    customOutline: {
        border: 'none',
        marginRight: 8,
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            // borderColor: theme.palette.secondary.main,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            // borderColor: theme.palette.secondary.main,
        },
        '&:focus-within': {
            border: 'none',
            // backgroundColor: theme.palette.secondary.main,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {
            border: 'none',
            // color: theme.palette.primary.main,
        },
        '& .MuiInputLabel-root.Mui-focused': {
            border: 'none',
            // color: theme.palette.primary.main,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
        {
            border: 'none',
            // borderColor: theme.palette.secondary.main,
        },

        '& .MuiInputBase-root': {
            color: 'white',
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            fontSize: 18,
            fontWeight: 700,
            // letterSpacing: '1.5px',
            marginTop: '2px',
            background: 'black',//'#002D62',
            // paddingLeft: '7px',
        },
        "& .MuiSvgIcon-root": {
            color: "white",
        },
        '& #demo-simple-select': {
            padding: '4px 32px 4px 14px',
        }
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '400px',
        width: '100%',
    },
    succesStatus: {
        width: '100%',
        padding: 5,
        backgroundColor: 'coloor of staus you can change as per requestStatus',
        borderRadius: 20,
    },
});

const Header = () => {
    const { instance } = useMsal();
    const agentState = useAgentState();
    const eventState = useEventState();
    const agentSaveAsDraftState = useAgentSaveAsDraftState();
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const agentInfo = Helper.getSessionStorage('agentUser');
    const impInfo = Helper.getStorage('impInfo');
    // const image_url = 'https://bbopsstoragedev.blob.core.windows.net/letsgo-dev-images/allStar.png';
    const classes = useStyles();
    const authState = useAuthState();
    const [userID, setUserID] = React.useState(0);
    const themeState = useThemeState();
    const notificationState = useNotificationState();
    const [isUserImpersonated, setIsUserImpersonated] = React.useState(false);
    const [state, setState] = React.useState(false);

    const [markReadIds, setMarkReadIds] = React.useState([]);
    const history = useHistory();
    //const profileData = useState(null)
    const agentConnection = Helper.getSessionStorage('agentConnections');
    // console.log("agentConnection",agentConnection);
    const agentUserImpersonate = (userId) => {
        const user = agentConnection.find((item) => item.userID === userId);

        ApiHelper.get()
            .then(async () => {
                let userEvents = null;
                let result = await ApiHelper.get(APIURLConstants.GET_EVENT(eventInfo.eventID, userId));
                userEvents = result ? result.data : null;
                eventState.eventDetail.set(userEvents);
                const path = generatePath(RouteConstants.EVENT_DETAIL, {
                    eventID: eventInfo.eventID,
                });
                history.push({
                    pathname: path,
                    state: { event: userEvents, changedUserByAgent: true },
                });

                //below code is added to check to show save as draft pop up in case of agent dropdown
                if (!agentSaveAsDraftState.showConfirmPopUp.get()) {
                    // Helper.setStorage('userInfo', user);
                    changeAgentUserHandler(user, userEvents)
                }
                else {
                    setAgentUserInfo(user);
                    agentSaveAsDraftState.userEvents.set(userEvents);
                }
            }).catch((err) => {
                resetSaveAsDraftState();
                //... Check if user's session has expired
                if (err.response && err.response.status === 401) {
                    console.log(err);
                }
            });
    };

    useEffect(() => {
        if (authState && authState.appDetails.isImpersonated.value) {
            setIsUserImpersonated(true);
        }
    }, [authState]);
    useEffect(() => {
        if (
            authState.appDetails !== undefined &&
            userID != (userInfo ? userInfo.userID : '')
        ) {
            setUserID(
                agentInfo ? agentInfo.userID : userInfo ? userInfo.userID : ''
            );
        }
    }, [authState, userInfo]);

    useEffect(() => {
        if (agentInfo) {
            setAgentVisible(agentInfo);
        }
    }, [agentInfo]);
    useEffect(() => {
        if (impInfo !== null) {
            getAppNotificationCount()
        }
    }, [impInfo]);
    useEffect(() => {
        setTimeout(() => {
            getAppNotificationCount();
        }, 2000);
        if (
            Helper.getFullURLSlug()[2] !== undefined &&
            Helper.getFullURLSlug()[2] !== '' &&
            !isNaN(Helper.getFullURLSlug()[2])
        ) {
            if (eventInfo?.eventID !== parseInt(Helper.getFullURLSlug()[2])) {
                ApiHelper.get(
                    APIURLConstants.GET_EVENT(Helper.getFullURLSlug()[2], 0)
                ).then((res) => {
                    Helper.setStorage('eventInfo', res.data);
                });
            }
        }
    }, []);
    const toggleDrawer = (open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setState(open);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [notificationDrawerEl, setNotificationDrawerEl] =
        React.useState(null);

    const isMenuOpen = Boolean(anchorEl);
    const isNotificationDrawerOpen = Boolean(notificationDrawerEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const [notificationData, setNotificationData] = React.useState([]);
    const [appNotificationLoader, setAppNotificationLoader] =
        React.useState(false);
    // const [appNotificationCount, setAppNotificationCount] = React.useState(0);

    const handleProfileMenuOpen = (event) => {
        getAppNotifications();
        // getAppNotificationCount();
        setAnchorEl(event.currentTarget);
    };
    const getAppNotifications = () => {
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        const userInfo = Helper.getStorage('userInfo');
        setAppNotificationLoader(true);
        let markIds = [];
        ApiHelper.get(APIURLConstants.GET_APP_NOTIFICATIONS(agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID))
            .then((res) => {
                if (res.data) {
                    setAppNotificationLoader(false);
                    setNotificationData(res.data);
                    res.data.map((item) => {
                        if (item.status === 0) {
                            markIds.push(item.appNotificationID);
                        }
                    });
                }
            })
            .catch((err) => {
                setAppNotificationLoader(false);
                console.log(err);
            });
        setTimeout(() => {
            setMarkReadIds(markIds);
        }, 1000);
    };
    const getAppNotificationCount = () => {
        const userInfo = Helper.getStorage('userInfo');
        const agentInfo = Helper.getStorage('agentInfo');
        const gAgentInfo = Helper.getStorage('agentUser');
        const agentConnection = Helper.getStorage('agentConnections');
        if (userInfo || agentInfo) {
            ApiHelper.get(
                APIURLConstants.GET_APP_NOTIFICATION_COUNT(
                    agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID
                )
            )
                .then((res) => {
                    setNotification({ notificationCount: res ? res.data : 0 });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };
    const handleNotificationDrawer = (event) => {
        getAppNotifications();
        getAppNotificationCount();
        setNotificationDrawerEl(event.currentTarget);
    };
    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };
    const handleNotificationDrawerClose = () => {
        setNotificationDrawerEl(null);
        // handleMobileMenuClose();
    };
    const handleLogout = () => {
        resetSaveAsDraftState();
        ApiHelper.get(APIURLConstants.SIGN_OUT).then(async (res) => {
            if (res.data) {
                unregister();
                if (Helper.getStorage('chk') == 'aad') {
                    localStorage.clear();
                    Helper.removeSessionStorage('agentConnections');
                    Helper.removeSessionStorage('agentUser');
                    window.history.pushState('', '', '/');
                    await instance.logoutRedirect();
                } else {
                    localStorage.clear();
                    window.location.href = '/';
                    Helper.removeSessionStorage('agentConnections');
                    Helper.removeSessionStorage('agentUser');
                    // authState.appDetails.signoutURL.value != undefined && authState.appDetails.signoutURL.value != ''
                    //         ? authState.appDetails.signoutURL.value
                    //         : '/';
                }
            }
        });
    };
    const handleClose = (event) => {
        if (anchorEl.current && anchorEl.current.contains(event.target)) {
            return;
        }

        setAnchorEl(false);
    };
    const handleNotificationClose = (event) => {
        if (
            notificationDrawerEl.current &&
            notificationDrawerEl.current.contains(event.target)
        ) {
            return;
        }
        setNotificationDrawerEl(false);
    };
    const markAllasRead = () => {
        setAppNotificationLoader(true);
        const updateData = {
            appNotificationIDs: markReadIds.toString(),
            status: 1,
            ModifiedBy: userInfo.userID,
        };
        ApiHelper.post(APIURLConstants.UPDATE_APP_NOTIFICATIONS, updateData)
            .then((res) => {
                if (res.data > 0) {
                    getAppNotifications();
                    getAppNotificationCount();
                    setAppNotificationLoader(false);
                }
            })
            .catch((err) => {
                setAppNotificationLoader(false);
                console.log('err', err);
            });
    };
    const viewAll = () => {
        setNotificationDrawerEl(null);
        history.push('/appNotifications');
    };
    const handleClick = () => {
        handleDrawerClose();
        setAnchorEl(null);
        setMobileMoreAnchorEl(null);
        history.push({
            pathname: RouteConstants.PROFILE,
        });
    };

    const removeImpersonate = () => {
        resetSaveAsDraftState();
        let getURL = APIURLConstants.SET_USER_AS(0);
        Helper.removeStorage('impInfo');
        Helper.removeSessionStorage('agentConnections');
        Helper.removeSessionStorage('agentUser');
        handleAgentClose();
        getAppNotificationCount();
        ApiHelper.get(getURL)
            .then(() => {
                history.push(RouteConstants.DASHBOARD, { rediretDashToHome: true });
                window.location.href = RouteConstants.DASHBOARD;
            })
            .catch((err) => {
                //... Check if user's session has expired
                if (err.response && err.response.status === 401) {
                    console.log(err);
                }
            });
    };
    // const handleMobileMenuOpen = (event) => {
    //     setMobileMoreAnchorEl(event.currentTarget);
    // };
    const DeleteNotification = (id) => {
        const userInfo = Helper.getStorage('userInfo');
        const deleteData = {
            AppNotificationIDs: id.toString(),
            ModifiedBy: userInfo.userID,
        };
        ApiHelper.post(APIURLConstants.DELETE_APP_NOTIFICATIONS, deleteData)
            .then((res) => {
                if (res.data) {
                    getAppNotifications();
                }
            })
            .catch((err) => {
                console.log('err', err);
            });
    };
    const UpdateNotification = (id, flag) => {
        const userInfo = Helper.getStorage('userInfo');
        const updateData = {
            appNotificationIDs: id.toString(),
            status: flag,
            ModifiedBy: userInfo.userID,
        };
        let newNotificationData = [...notificationData];
        newNotificationData.map((item) => {
            item.status = item.appNotificationID == id ? flag : item.status;
        });
        setNotificationData(newNotificationData);
        ApiHelper.post(APIURLConstants.UPDATE_APP_NOTIFICATIONS, updateData)
            .then((res) => {
                if (res.data > 0) {
                    //getAppNotifications();
                    getAppNotificationCount();
                }
            })
            .catch((err) => {
                console.log('err', err);
            });
    };

    const notificationItemClick = async (item, flag) => {
        if (item.status === 0) {
            UpdateNotification(item.appNotificationID, flag);
        }
        if (item.connectionName != '') {
            ApiHelper.get(APIURLConstants.GET_EVENT(item.eventID, 0)).then(
                (res) => {
                    if (res.data) {
                        const eventData = res.data;
                        Helper.setStorage('eventInfo', eventData);
                        ApiHelper.get(
                            APIURLConstants.GET_EVENT_CONFIG(item.eventID)
                        ).then((res) => {
                            Helper.setStorage('eventModuleConfig', res.data);
                        });

                        const gUserInfo = Helper.getStorage('userInfo');
                        Helper.setStorage('agentInfo', gUserInfo);
                        let path = generatePath(
                            RouteConstants.EVENT_AGENT_PROFILE,
                            {
                                eventID: item.eventID,
                            }
                        );

                        history.push({
                            pathname: path,
                            state: { event: eventData },
                        });
                    }
                }
            );
        } else {
            let pathName = getModulePathName(item);
            if (pathName != null) {
                const userEvents = Helper.getStorage('UserEvents');
                let data;
                if (eventInfo === null) {
                    data =
                        userEvents &&
                        userEvents.filter(
                            (event) => event.eventID === item.eventID
                        );
                    //added below to fetch modulesDetails
                    if (data && data[0] && !data[0].moduleDetails) {
                        let moduleDetailResult = await ApiHelper.get(APIURLConstants.GET_EVENT_MODULE_DETAILS(item.eventID));
                        if (moduleDetailResult) {
                            data[0].moduleDetails = moduleDetailResult.data;
                        }
                    }

                    if (data) {
                        Helper.setStorage('eventInfo', data[0]);
                    }

                    history.push({
                        pathname: pathName,
                        state: { displayName: item.moduleName }
                    });
                } else {

                    if (eventInfo && eventInfo.eventID !== item.eventID) {
                        const event = ApiHelper.get(
                            APIURLConstants.GET_EVENT(item.eventID, 0)
                        );
                        const eventConfig = ApiHelper.get(
                            APIURLConstants.GET_EVENT_CONFIG(
                                item.eventID
                            )
                        );
                        await Promise.all([event, eventConfig]).then((result) => {
                            const eventData = result[0].data;
                            Helper.setStorage('eventInfo', eventData);

                            Helper.setStorage('eventModuleConfig', result[1].data);

                            history.push({
                                pathname: pathName,
                                state: { displayName: item.moduleName }
                            });

                        }).catch(err => {
                            console.log('error while fetching Event Info', err);
                        });
                    }
                    else {
                        history.push({
                            pathname: pathName,
                            state: { displayName: item.moduleName }
                        });
                    }
                }

                handleNotificationDrawerClose();
                location.reload();
            }
        }
    };

    const getModulePathName = (item) => {
        let path =
            item.moduleID === 1
                ? generatePath(RouteConstants.EVENT_TRANSIT, {
                    eventID: item.eventID,
                })
                : item.moduleID === 2
                    ? generatePath(RouteConstants.EVENT_REGISTER_CREATE, {
                        eventID: item.eventID,
                    })
                    : item.moduleID === 3
                        ? generatePath(RouteConstants.EVENT_INVITATIONS, {
                            eventID: item.eventID,
                        })
                        : item.moduleID === 4
                            ? generatePath(RouteConstants.EVENT_HOTEL, {
                                eventID: item.eventID,
                            })
                            : item.moduleID === 5
                                ? generatePath(RouteConstants.CREATE_OUTFIT, {
                                    eventID: item.eventID,
                                })
                                : item.moduleID === 6
                                    ? generatePath(RouteConstants.EVENT_DRAFT_REGISTER_CREATE, {
                                        eventID: item.eventID,
                                    })
                                    : item.moduleID === 7
                                        ? generatePath(RouteConstants.EVENT_ALLSTAR_HOTEL, {
                                            eventID: item.eventID,
                                        })
                                        : item.moduleID === 22
                                            ? generatePath(RouteConstants.EVENT_DRAFT_HOTEL, {
                                                eventID: item.eventID,
                                            })
                                            : item.appNotificationTypeID === 8
                                                ? generatePath(RouteConstants.EVENT_NOTES_USER, {
                                                    eventID: item.eventID,
                                                })
                                                : item.moduleID === 8
                                                    ? generatePath(RouteConstants.CREATE_EVENT_TICKET, {
                                                        eventID: item.eventID,
                                                    })
                                                    : item.moduleID === 9
                                                        ? generatePath(RouteConstants.EVENT_DETAIL, {
                                                            eventID: item.eventID,
                                                        })
                                                        : item.moduleID === 10
                                                            ? generatePath(RouteConstants.USER_ACTIVITIES, {
                                                                eventID: item.eventID,
                                                            })
                                                            : item.moduleID === 11
                                                                ? generatePath(RouteConstants.MY_RESOURCE, {
                                                                    eventID: item.eventID,
                                                                })
                                                                : item.moduleID === 12
                                                                    ? generatePath(
                                                                        RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_ENDUSER_CREATE,
                                                                        {
                                                                            eventID: item.eventID,
                                                                        }
                                                                    )
                                                                    : item.moduleID === 23
                                                                        ? generatePath(
                                                                            RouteConstants.PRIVATE_VEHICLE_ENDUSER_CREATE,
                                                                            {
                                                                                eventID: item.eventID,
                                                                            }
                                                                        )
                                                                        : item.moduleID === 13
                                                                            ? generatePath(RouteConstants.CREATE_EVENT_VIP, {
                                                                                eventID: item.eventID,
                                                                            })
                                                                            : item.moduleID === 16
                                                                                ? generatePath(RouteConstants.EVENT_STAFF_SCHEDULE, {
                                                                                    eventID: item.eventID,
                                                                                })
                                                                                : item.moduleID === 18
                                                                                    ? generatePath(
                                                                                        RouteConstants.EVENT_ALLSTAR_REGISTER_CREATE,
                                                                                        {
                                                                                            eventID: item.eventID,
                                                                                        }
                                                                                    )
                                                                                    : item.moduleID === 17
                                                                                        ? generatePath(
                                                                                            Helper.isAdminUser(userInfo)
                                                                                                ? RouteConstants.All_STAR_TIKCET
                                                                                                : RouteConstants.All_STAR_END_USER_TIKCETS,
                                                                                            {
                                                                                                eventID: item.eventID,
                                                                                            }
                                                                                        )
                                                                                        : item.moduleID === 20
                                                                                            ? generatePath(
                                                                                                Helper.isAdminUser(userInfo)
                                                                                                    ? RouteConstants.DRAFT_EVENT_TRANSIT_LIST
                                                                                                    : RouteConstants.DRAFT_EVENT_TRANSIT,
                                                                                                {
                                                                                                    eventID: item.eventID,
                                                                                                }
                                                                                            )
                                                                                            : item.moduleID === 21
                                                                                                ? generatePath(
                                                                                                    Helper.isAdminUser(userInfo)
                                                                                                        ? RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT_LIST
                                                                                                        : RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT,
                                                                                                    {
                                                                                                        eventID: item.eventID,
                                                                                                    }
                                                                                                ) : item.moduleID === 25
                                                                                                ? generatePath(
                                                                                                    Helper.isAdminUser(userInfo)
                                                                                                        ? RouteConstants.CREDENTIAL_LIST
                                                                                                        : RouteConstants.CREDENTIALS,
                                                                                                    {
                                                                                                        eventID: item.eventID,
                                                                                                    }
                                                                                                ) : item.moduleID === 26
                                                                                                    ? generatePath(
                                                                                                        Helper.isAdminUser(userInfo)
                                                                                                            ? RouteConstants.COMBINE_FLIGHT_INFOLIST
                                                                                                            : RouteConstants.COMBINE_FLIGHT_INFO,
                                                                                                        {
                                                                                                            eventID: item.eventID,
                                                                                                        }
                                                                                                )
                                                                                                : item.moduleID === 27
                                                                                                ? generatePath(
                                                                                                    Helper.isAdminUser(userInfo)
                                                                                                        ? RouteConstants.LUNCHROOM_LIST
                                                                                                        : RouteConstants.LUNCHROOM,
                                                                                                    {
                                                                                                        eventID: item.eventID,
                                                                                                    }
                                                                                                ) : item.moduleID === 28
                                                                                                ? generatePath(
                                                                                                    Helper.isAdminUser(userInfo)
                                                                                                        ? RouteConstants.GREENROOM_LIST
                                                                                                        : RouteConstants.GREENROOM,
                                                                                                    {
                                                                                                        eventID: item.eventID,
                                                                                                    }
                                                                                                )
                                                                                                // : item.moduleID === 22
                                                                                                // ? generatePath(
                                                                                                //       Helper.isAdminUser(userInfo)
                                                                                                //           ? RouteConstants.EVENT_DRAFT_HOTEL_BOOKING_LIST
                                                                                                //           : RouteConstants.CREATE_DRAFT_EVENT_HOTEL,
                                                                                                //       {
                                                                                                //           eventID: item.eventID,
                                                                                                //       }
                                                                                                //   )
                                                                                                : null;

        return path;

    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Popper
            style={{ zIndex: 9999 }}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            placement="top-end"
            open={isMenuOpen}
            onClose={handleMenuClose}>
            <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                    <Box>
                        {!Helper.isPaymentUser(userInfo && userInfo) ? (
                            <MenuItem onClick={handleClick}>Profile</MenuItem>
                        ) : null}
                        {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Box>
                </ClickAwayListener>
            </Paper>
        </Popper>
    );
    const renderNotificationDrawer = (
        <Popper
            style={{ zIndex: 9999 }}
            anchorEl={notificationDrawerEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            placement="top-end"
            open={isNotificationDrawerOpen}
            onClose={handleNotificationDrawerClose}>
            <Paper scroll="paper">
                <ClickAwayListener onClickAway={handleNotificationClose}>
                    <Card sx={{ width: '550px' }}>
                        <CardHeader
                            title={
                                <Typography varient="h3">
                                    Notifications
                                </Typography>
                            }
                            action={
                                <Typography
                                    sx={{
                                        fontSize: '12px',
                                        color: '#06255B',
                                        display: 'flex',
                                        marginTop: '10px',
                                        marginRight: '10px',
                                    }}
                                    varient="body2">
                                    <Box
                                        component="span"
                                        sx={{ cursor: 'pointer' }}
                                        onClick={viewAll}>
                                        View All
                                    </Box>{' '}
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{
                                            marginLeft: '5px',
                                            marginRight: '5px',
                                            background: 'black',
                                        }}
                                    />{' '}
                                    <Box
                                        component="span"
                                        sx={{ cursor: 'pointer' }}
                                        onClick={
                                            markReadIds.length > 0
                                                ? markAllasRead
                                                : null
                                        }>
                                        {' '}
                                        Mark All as Read
                                    </Box>
                                </Typography>
                            }></CardHeader>
                        <Divider />
                        {appNotificationLoader ? (
                            <Box className={classes.loader}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <List
                                component="nav"
                                sx={{
                                    overflow: 'auto',
                                    height: '400px',
                                    '&::-webkit-scrollbar': {
                                        width: '0.4em',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        boxShadow:
                                            'inset 0 0 6px rgba(0,0,0,0.00)',
                                        webkitBoxShadow:
                                            'inset 0 0 6px rgba(0,0,0,0.00)',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: 'rgba(0,0,0,.1)',
                                        // outline: '1px solid slategrey'
                                    },
                                    p: 0,
                                    fontSize: '12px',
                                    '& .MuiListItemButton-root': {
                                        py: 0.5,
                                        '& .MuiAvatar-root': '',
                                        '& .MuiListItemSecondaryAction-root': {
                                            position: 'relative',
                                        },
                                    },
                                }}>
                                {notificationData.length > 0
                                    ? notificationData.map((item, i) => {
                                        return (
                                            <>
                                                <ListItemButton
                                                    sx={{
                                                        backgroundColor:
                                                            item.status === 0
                                                                ? '#e3e6ea'
                                                                : '',
                                                    }}
                                                    key={i}>
                                                    <ListItemText
                                                        primary={
                                                            item.appNotificationTypeID ===
                                                                1 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    :{' '}
                                                                    {item.connectionName !==
                                                                        ''
                                                                        ? item.connectionName
                                                                        : 'Your'}{' '}
                                                                    {item.moduleName ==
                                                                        'DraftHotel'
                                                                        ? 'Player Hotel'
                                                                        : item.moduleName}{' '}
                                                                    Request is{' '}
                                                                    {item.requestStatus ===
                                                                        2 ? (
                                                                        <Typography
                                                                            variant="span"
                                                                            sx={{
                                                                                color: 'white',
                                                                                backgroundColor:
                                                                                    'green',
                                                                                borderRadius: 10,
                                                                                textAlign:
                                                                                    'center',
                                                                                paddingY:
                                                                                    '3px',
                                                                                paddingX:
                                                                                    '10px',
                                                                            }}>
                                                                            Approved
                                                                        </Typography>
                                                                    ) : item.requestStatus ===
                                                                        3 ? (
                                                                        <Typography
                                                                            variant="span"
                                                                            sx={{
                                                                                color: 'white',
                                                                                backgroundColor:
                                                                                    'red',
                                                                                borderRadius: 10,
                                                                                textAlign:
                                                                                    'center',
                                                                                paddingY:
                                                                                    '3px',
                                                                                paddingX:
                                                                                    '10px',
                                                                                whiteSpace:'nowrap',
                                                                            }}>
                                                                            Not Approved
                                                                        </Typography>
                                                                    ) : (
                                                                        <Typography
                                                                            variant="span"
                                                                            sx={{
                                                                                color: 'white',
                                                                                backgroundColor:
                                                                                    '#F9B811',
                                                                                borderRadius: 10,
                                                                                textAlign:
                                                                                    'center',
                                                                                paddingY:
                                                                                    '3px',
                                                                                paddingX:
                                                                                    '10px',
                                                                            }}>
                                                                            Pending
                                                                        </Typography>
                                                                    )}
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                2 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : Event
                                                                    admin has
                                                                    shared new
                                                                    resource{' '}
                                                                    {item.resourceName
                                                                        ? item.resourceName
                                                                        : ''}{' '}
                                                                    with{' '}
                                                                    {item.connectionName !==
                                                                        ''
                                                                        ? item.connectionName
                                                                        : 'you'}
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                3 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : Schedule
                                                                    is shared
                                                                    with{' '}
                                                                    {item.connectionName !==
                                                                        ''
                                                                        ? item.connectionName
                                                                        : 'you'}
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                4 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : is
                                                                    published
                                                                    please
                                                                    visit
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                5 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : Schedule
                                                                    is
                                                                    Unpublished
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                6 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : Staff
                                                                    Schedule
                                                                    is shared
                                                                    with{' '}
                                                                    {item.connectionName !==
                                                                        ''
                                                                        ? item.connectionName
                                                                        : 'you'}
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                7 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : Staff
                                                                    Schedule
                                                                    is
                                                                    Unpublished{' '}
                                                                    {item.connectionName !==
                                                                        ''
                                                                        ? item.connectionName
                                                                        : ''}
                                                                </Typography>
                                                            ) : item.appNotificationTypeID ===
                                                                8 ? (
                                                                <Typography
                                                                    variant="subtitle2"
                                                                    sx={{
                                                                        fontWeight:
                                                                            item.status ===
                                                                                1
                                                                                ? 100
                                                                                : '',
                                                                    }}>
                                                                    {
                                                                        item.eventName
                                                                    }
                                                                    : there is
                                                                    a note for
                                                                    you{' '}
                                                                </Typography>
                                                            ) : (
                                                                ''
                                                            )
                                                        }
                                                        secondary={
                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    fontWeight:
                                                                        item.status ===
                                                                            1
                                                                            ? 100
                                                                            : '',
                                                                }}>
                                                                {' '}
                                                                {Helper.FormatDateTime(
                                                                    item.createdDate
                                                                )}
                                                                :{' '}
                                                                {
                                                                    item.submittedBy
                                                                }
                                                            </Typography>
                                                        }
                                                        // onClick={() => item.status === 0 ? UpdateNotification(item.appNotificationID) : ""}
                                                        onClick={() =>
                                                            notificationItemClick(
                                                                item,
                                                                1
                                                            )
                                                        }
                                                    />
                                                    <ListItemSecondaryAction
                                                        sx={{
                                                            width: 80,
                                                            display: 'flex',
                                                            justifyContent:
                                                                'right',
                                                            marginRight:
                                                                '-17px',
                                                            marginLeft:
                                                                '15px',
                                                        }}>
                                                        <Avatar
                                                            title="Delete"
                                                            sx={{
                                                                width: 15,
                                                                height: 15,
                                                                color: '#06255B',
                                                                bgcolor:
                                                                    'white',
                                                                overflow:
                                                                    'inherit',
                                                                marginRight:
                                                                    '13px',
                                                            }}>
                                                            <CancelOutlinedIcon
                                                                onClick={() =>
                                                                    DeleteNotification(
                                                                        item.appNotificationID
                                                                    )
                                                                }
                                                            />
                                                        </Avatar>

                                                        <Avatar
                                                            title={
                                                                item.status ==
                                                                    0
                                                                    ? 'Mark as read'
                                                                    : 'Mark as unread'
                                                            }
                                                            sx={{
                                                                width: 15,
                                                                height: 15,
                                                                color:
                                                                    item.status ===
                                                                        1
                                                                        ? '#8b8484'
                                                                        : '#06255B',
                                                            }}>
                                                            <FiberManualRecordIcon
                                                                onClick={() =>
                                                                    UpdateNotification(
                                                                        item.appNotificationID,
                                                                        item.status ==
                                                                            0
                                                                            ? 1
                                                                            : 0
                                                                    )
                                                                }
                                                            />
                                                        </Avatar>
                                                    </ListItemSecondaryAction>
                                                </ListItemButton>
                                                <Divider />
                                            </>
                                        );
                                    })
                                    : ''}
                            </List>
                        )}
                    </Card>
                </ClickAwayListener>
            </Paper>
        </Popper>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    // const userInfo = Helper.getStorage('userInfo');
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}>
            <MenuItem>
                <IconButton
                    size="large"
                    aria-label="show 4 new mails"
                    color="inherit">
                    <Badge badgeContent={0} color="error">
                        <MailIcon />
                    </Badge>
                </IconButton>
                <p>Messages</p>
            </MenuItem>
            {/* <MenuItem>
                <IconButton
                    size="large"
                    aria-label="show 17 new notifications"
                    color="inherit">
                    <Badge badgeContent={17} color="error">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
                <p>Notifications</p>
            </MenuItem> */}
            <MenuItem
                onClick={
                    isUserImpersonated
                        ? removeImpersonate
                        : handleProfileMenuOpen
                }>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit">
                    {isUserImpersonated ? (
                        <Badge
                            overlap="circular"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            badgeContent={
                                <CloseIcon
                                    fontSize="small"
                                    className={classes.setScale}></CloseIcon>
                            }>
                            <ProfileInitial
                                data={Helper.getStorage('userInfo')}
                                navigationScreen={'profile'}
                            />
                        </Badge>
                    ) : (
                        <ProfileInitial
                            data={Helper.getStorage('userInfo')}
                            navigationScreen={'profile'}
                        />
                    )}
                </IconButton>
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );
    const list = () => (
        <Box
            sx={{
                width: 250,
                // height: '100vh',

                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            }}
            role="presentation">
            <Box
                sx={{
                    display: 'flex',
                    // flexDirection: 'row',
                    justifyContent: 'center',
                    textAlign: 'center',
                    background: themeState.primary.value,
                    pt: 4,
                    pb: 2,
                }}>
                <ProfileInitial
                    data={Helper.getStorage('userInfo')}
                    navigationScreen={'profile'}
                    size={50}
                />
                {/* <Box
                    component="img"
                    className={classes.mobileLogo}
                    alt="logo."
                    src={Logo}
                /> */}
                {/* <Typography
                    variant="h4"
                    fontFamily="Action NBA"
                    lineHeight="43.6px"
                    fontSize={44}
                    component="div"
                    color="white">
                    LETSGO
                </Typography> */}
            </Box>
            <Box
                sx={{
                    background: themeState.primary.value,
                }}>
                <Typography variant="body2" className={classes.whiteFontColor}>
                    {' '}
                    Hello!
                </Typography>
            </Box>
            <Box
                sx={{
                    background: themeState.primary.value,
                    pb: 2,
                }}>
                <Typography variant="body1" className={classes.whiteFontColor}>
                    <b>
                        {userInfo && userInfo.firstName} &nbsp;
                        {userInfo && userInfo.lastName}
                    </b>
                </Typography>
            </Box>
            <NavBar />
        </Box>
    );

    // console.log(agentInfo);
    const redirectToAgentProfile = () => {
        handleDrawerClose();
        Helper.removeStorage('agentConnections');
        const path = generatePath(RouteConstants.EVENT_AGENT_PROFILE, {
            eventID: eventInfo.eventID,
        });
        history.push({
            pathname: path,
            state: { event: eventInfo },
        });
    }
    return (
        <>
            <Box sx={{ flexGrow: 1 }} >
                <AppBar position="fixed"
                    sx={{ background: '#17408B' }}
                >
                    <Toolbar className={classes.headerTilte}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'left',
                                alignItems: 'center',
                                background: themeState.eventEnabled.value ? 'white' : '#17408B',
                                borderRight: themeState.eventEnabled.value ? '50px solid transparent' : '', // Adjust the slant size
                                borderBottom: themeState.eventEnabled.value ? '0px solid #17408B' : '', // Adjust the slant size and color
                                clipPath: themeState.eventEnabled.value ? 'polygon(0% 0%, 0% 100%, 78% 100%, 100% 0%)' : '',
                                boxSizing: 'border-box',
                                height: '100%',
                                width: 'fit-content',
                                padding: '5px 0px 5px 5px'
                            }}
                        >
                            <Box
                                component="img"
                                className={classes.logo}
                                alt="logo."
                                src={
                                    !themeState.eventEnabled.value
                                        ? Logo
                                        : themeState.eventImageUrl.value != ''
                                            ? themeState.eventImageUrl.value
                                            : DefaultEvent
                                }
                            />
                        </Box>
                        {themeState.eventEnabled.value && (
                            <Box
                                sx={{
                                    display: { xs: 'none', md: 'flex' },
                                    flexDirection: 'column',
                                    paddingLeft: 1,
                                    justifyContent: 'space-evenly',
                                    mt: '1px',
                                    ml: '5px',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontFamily="Action NBA"
                                    noWrap
                                    fontStyle="normal"
                                    fontWeight="500"
                                    fontSize={58}
                                    color="white"
                                    letterSpacing="1.5px"
                                    component="div">
                                    {eventInfo ? eventInfo.eventName : ""}
                                </Typography>
                            </Box>
                        )}
                        <Box sx={{ flexGrow: 1 }} />
                        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                            {(history?.location?.pathname != "/events/agent") ? (history?.location?.pathname != "/") ? agentConnection && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        px: 1,
                                        paddingRight: 0,
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        boxShadow:
                                            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
                                        borderRadius: 1,
                                        backgroundColor: 'yellow',
                                        marginTop: 1,
                                        marginBottom: 1,
                                        paddingBottom: '2px',
                                        bgcolor: 'yellow',
                                        color: 'white',
                                        border: '1px solid'
                                    }}
                                >
                                    <Typography
                                        fontWeight={700}
                                        sx={{ cursor: 'pointer', pr: 1.4, pt: '3px' }}
                                        fontSize={18}
                                        color={'black'}
                                        onClick={redirectToAgentProfile}>
                                        Acting on behalf of
                                    </Typography>
                                    {/* <ProfileInitial
                                        data={Helper.getStorage('userInfo')}
                                        navigationScreen={'profile'}
                                    /> */}
                                    <FormControl
                                        classes={{
                                            root: classes.customOutline,
                                        }}
                                        fullWidth={false}
                                        size="small">
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={
                                                agentInfo
                                                    ? agentInfo.userID
                                                    : agentState.user.get()
                                                        ? agentState.user.get()
                                                            .userID
                                                        : ''
                                            }
                                            onChange={(event) => {
                                                agentUserImpersonate(
                                                    event.target.value
                                                );
                                            }}>
                                            {agentConnection.length > 0 &&
                                                agentConnection.map(
                                                    (option) => {
                                                        if (option.userRoleType == "EventAdmin" || option.userType == "Admin") {
                                                            return (
                                                                <MenuItem
                                                                    key={option.userID}
                                                                    value={
                                                                        option.userID
                                                                    }>
                                                                    {option.firstName +
                                                                        ' ' +
                                                                        option.lastName}
                                                                </MenuItem>
                                                            )
                                                        } else {
                                                            if (option.isPublished) {
                                                                return (
                                                                    <MenuItem
                                                                        key={option.userID}
                                                                        value={
                                                                            option.userID
                                                                        }>
                                                                        {option.firstName +
                                                                            ' ' +
                                                                            option.lastName}
                                                                    </MenuItem>
                                                                )
                                                            }
                                                        }

                                                    }
                                                )}
                                        </Select>
                                    </FormControl>
                                </Box>
                            ) : null : null}

                            <IconButton
                                size="large"
                                color="inherit"
                                onClick={handleNotificationDrawer}>
                                <Badge
                                    badgeContent={
                                        notificationState
                                            .attach(Downgraded)
                                            .get().notificationCount
                                    }
                                    color="error">
                                    <CircleNotificationsIcon fontSize="large" />
                                </Badge>
                            </IconButton>
                            <IconButton
                                size="large"
                                edge="end"
                                aria-label="account of current user"
                                aria-controls={menuId}
                                aria-haspopup="true"
                                onClick={
                                    isUserImpersonated
                                        ? removeImpersonate
                                        : handleProfileMenuOpen
                                }
                                color="inherit"
                                className={classes.initialSection}>
                                {/* <AccountCircle /> */}
                                {isUserImpersonated ? (
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        badgeContent={
                                            <CloseIcon
                                                fontSize="small"
                                                className={
                                                    classes.setScale
                                                }></CloseIcon>
                                        }>
                                        <ProfileInitial
                                            data={Helper.getStorage('userInfo')}
                                            navigationScreen={'profile'}
                                        />
                                    </Badge>
                                ) : (
                                    <ProfileInitial
                                        data={Helper.getStorage('userInfo')}
                                        navigationScreen={'profile'}
                                    />
                                )}
                            </IconButton>
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="show more"
                                aria-controls={mobileMenuId}
                                aria-haspopup="true"
                                onClick={toggleDrawer(true)}
                                color="inherit">
                                <MenuIcon />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </AppBar>
                {/* <Badge
                    badgeContent={
                        notificationState.attach(Downgraded).get()
                            .notificationCount
                    }
                    color="primary">
                    <CircleNotificationsIcon color="action" />
                </Badge> */}
                {renderMobileMenu}
                {renderNotificationDrawer}
                {renderMenu}
            </Box>
            <SwipeableDrawer
                open={state}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}>
                {list()}
            </SwipeableDrawer>
        </>
    );
};
export default Header;
